import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { GitMerge, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SEVEN_DAYS = 7 * 24 * 3600 * 1000;

/** "Pipeline recalculated" notice shown for 7 days after a lead-identity merge (dismissible per merge). */
export function PipelineMergeBanner() {
  const [merge, setMerge] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/api/admin/lead-identities/last-merge`, { withCredentials: true })
      .then((r) => setMerge(r.data?.merge || null)).catch(() => setMerge(null));
  }, []);
  if (!merge?.at) return null;
  const at = new Date(merge.at);
  if (Number.isNaN(at.getTime()) || Date.now() - at.getTime() > SEVEN_DAYS) return null;
  if (localStorage.getItem('bp-pipeline-merge-dismissed') === merge.at) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 mb-3 text-xs text-emerald-900" role="status" data-testid="pipeline-merge-banner">
      <GitMerge className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" />
      <p className="flex-1">
        <span className="font-semibold">Pipeline recalculated.</span>{' '}
        {merge.rep_name || merge.rep_email || 'A rep'}'s {merge.field === 'cs_lead' ? 'CS' : 'Sales'} lead assignments were consolidated
        ({merge.estimates_updated} estimate{merge.estimates_updated === 1 ? '' : 's'} moved from {merge.merged_ids} stale id{merge.merged_ids === 1 ? '' : 's'})
        on {at.toLocaleDateString()} by {merge.by || 'an admin'} — each rep now appears once below.
      </p>
      <button type="button" onClick={() => { localStorage.setItem('bp-pipeline-merge-dismissed', merge.at); setMerge(null); }}
        className="text-emerald-700 hover:text-emerald-900" title="Dismiss" data-testid="pipeline-merge-banner-dismiss">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
